import { type User } from '@/types/user';

/** Up to two initials for the avatar: first and last name, or the first two letters. */
export const getUserInitials = (user?: Pick<User, 'firstName' | 'lastName'> | null) => {
  if (!user?.firstName) return '';
  const first = user.firstName.trim();
  const last = user.lastName?.trim();
  const initials = last ? `${first[0]}${last[0]}` : first.slice(0, 2);
  return initials.toUpperCase();
};
